module.exports = __webpack_public_path__ + "img/mainImg.270832a9.png";